/**
 * Shared copy for the "at cap" tooltip rendered on Negotiate buttons across
 * FeedListingCard, StickyBottomBar, and ListingDetailScreen. Trial users get
 * an extra nudge that upgrading to Pro raises the cap; everyone else gets the
 * plain "complete or close one" line.
 *
 * `activeLimit === 1` corresponds to TRIAL_ACTIVE_LIMIT in NegotiationContext
 * — paid Pro and grandfather entitlements always get 5. Free/none users
 * never reach this UI (paywalled upstream), so a 1-cap effectively maps to
 * trial in production.
 */
export function getNegotiationCapCopy(activeLimit) {
  if (activeLimit <= 1) {
    return "You're at the 1-negotiation trial limit. Complete or close one, or upgrade to Pro to run up to 5 at a time.";
  }
  return `You're at the ${activeLimit}-negotiation limit. Complete or close one to start another.`;
}
